module.exports = __webpack_public_path__ + "media/buy-now/crema-cash-5-04290daf.png";